import { Injectable } from '@angular/core';

import { prepare } from '@core/operators';
import { Observable, Subject } from 'rxjs';
import { filter, finalize, map } from 'rxjs/operators';

import { ApplicationEvent, LoadingEvent } from '@core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  event$ = new Subject<ApplicationEvent>();
  loading$ = new Subject<LoadingEvent>();

  constructor() {}

  loading = (id: string) =>
    this.loading$.pipe(
      filter((x) => x.id === id),
      map((x) => x.state)
    );

  indicate<T>(id: string): (source: Observable<T>) => Observable<T> {
    return (source$: Observable<T>): Observable<T> =>
      source$.pipe(
        prepare(() => this.loading$.next({ id, state: true })),
        finalize(() => this.loading$.next({ id, state: false }))
      );
  }
}
